import debug from 'debug';

export const log = debug('terralego:Api');

export default log;
